<template>
  <div
    aria-hidden="true"
    :class="['poster-zapping-number', { 'hide-from-medium': visibility === ZAPPING_NUMBER_VISIBILITY.MOBILE }]"
    data-wptv="item-poster-zapping-number">
    {{ zappingNumber }}.
  </div>
</template>

<script>
import WptvPosterConfig from '../poster.config'

export default {
  name: 'PosterZappingNumber',
  props: {
    visibility: {
      type: String,
      required: true
    },
    zappingNumber: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      ZAPPING_NUMBER_VISIBILITY: WptvPosterConfig.ZAPPING_NUMBER_VISIBILITY
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../../../scss/abstracts/variables';
  @import '../../../scss/abstracts/mixins';

  .poster-zapping-number {
    position: absolute;
    z-index: 3;
    object-fit: scale-down;
    bottom: 10px;
    left: 10px;
    font-family: $main-font-family;
    color: $white;
  }
</style>
